@if (isSubStrategyCreation() && strategyGroup()) {
  <div class="flex items-center justify-between" *transloco="let t" appNavBreadcrumb>
    <div class="type-body-medium text-muted-foreground flex items-center">
      <a iButton variant="ghost" routerLink=".." [queryParams]="{ preserve: true }">
        {{ strategyGroup()!.strategyGroupName }}
      </a>
      <span class="type-body text-subtle-foreground">/</span>
      <span class="text-foreground ml-1">{{
        t("sp-substrategy-creation.new_strategy", [strategyTypeStr() | titlecase])
      }}</span>
    </div>
  </div>
}
<app-form-shell *transloco="let t">
  <div shellHeader>
    <IStepper [steps]="formSteps()" [form]="creationForm" (stepSelect)="goToStep($event)" clickable />
  </div>
  <div shellMain class="h-full min-h-0">
    @switch (currentStepId()) {
      @case ("setup") {
        <app-sp-create-strategy-setup [setup]="creationForm.setup" />
      }
      @case ("algorithm") {
        <app-sp-create-strategy-algorithm [algorithm]="creationForm.algorithm" />
      }
      @case ("asins") {
        <app-sp-create-strategy-asins
          [asins]="creationForm.asins"
          [customList]="strategyType() === StrategyType.PRODUCT ? undefined : strategyGroup()?.asins"
          [excludedAsins]="strategyType() === StrategyType.PRODUCT && strategyGroup() ? strategyGroup()!.asins : []"
        />
      }
      @case ("targetings") {
        <app-sp-create-strategy-targetings [targetings]="creationForm.targetings" [strategyType]="strategyType()" />
      }
    }
  </div>
  <div shellFooter class="flex items-center justify-between">
    <button iButton variant="secondary" type="button" [disabled]="isCreatingStrategy()" (click)="cancel()">
      {{ t("common.cancel") }}
    </button>
    <div class="flex items-center gap-3">
      @if (!isFirstStep()) {
        <button iButton variant="secondary" [disabled]="isCreatingStrategy()" (click)="back()">
          {{ t("common.back") }}
        </button>
      }
      <button
        iButton
        [disabled]="!canGoNext() || (creationForm().invalid() && isLastStep())"
        [loading]="isCreatingStrategy()"
        [testId]="isLastStep() ? 'create-strategy-button' : 'next-button'"
        (click)="next()"
      >
        {{
          isLastStep()
            ? isCreatingStrategy()
              ? t("common.creating_your_strategy")
              : t("common.create_strategy")
            : t("common.next")
        }}
      </button>
    </div>
  </div>
</app-form-shell>
